/**
   * Displays the color swatches based on the metafield called variants.color
   * which consists of all related product handles, excluding itself.
   */

const multiCreateSizedImageUrl = (src, width) => {
  if (typeof src !== 'string' || !width) {
    return src;
  }
  const indexOfLastDot = src.lastIndexOf('.');
  const name = src.substr(0, indexOfLastDot);
  const extension = src.substr(indexOfLastDot);
  return `${name}_${width}x${extension}`;
};

const multicreateSwatchSrcSet = (src) => {
  const transformedSrcSet = `${multiCreateSizedImageUrl(
  src,
  20
)} 1x, ${multiCreateSizedImageUrl(src, 40)} 2x`;
  return transformedSrcSet;
};

const retrieveMultiProduct = (
  colorsElement,
  colorObj,
  retrieveType,
  prodItem,
  productInfo,
  specificProductRelatedColors
) => {
  let colorHandle = colorObj.handle;
  let colorSwatch = '';
  let colorSwatchImage = '';
  let currentProductHandle = '';
  let formColors = '';

  if (retrieveType == 'product') {
    currentProductHandle = currentProductHandle;
    formColors = document.querySelector('.js-form-colors');
  } else {
    currentProductHandle = productInfo.dataset.productHandle;
    formColors = specificProductRelatedColors;
  }
  const swatchType = colorObj.metafields[0].swatch_type;
  const colorHex = colorObj.metafields[0].swatch_hex;
  const colorSwatchImg = colorObj.metafields[0].swatch_img;
  const colorURL = window.Shopify.routes.root + (colorObj.url.startsWith('/') ? colorObj.url.substring(1) : colorObj.url);
  const colorId = 'color--' + colorObj.id;
  const colorTitle = colorObj.color.toLowerCase();
  const featImg = colorObj.featured_image;
  const imgObj = colorObj.images[1];
  const isImage = swatchType.toLowerCase().includes('image');
  let altImg = null;
  let metaImage = colorObj.metafields[0].swatch_img;

  // bug fix when sometimes the metafield is an object
  if (metaImage && typeof metaImage === 'object') {
    metaImage = metaImage.src;
  }

  if (imgObj && imgObj.src) {
    altImg = colorObj.images[1].src;
  }
  const colorPrice = colorObj.price;
  const colorComparePrice = colorObj.compare_at_price;
  const productId = colorObj.id;
  const productAvailability = colorObj.available;
  const productHandle = colorObj.handle;
  const productFirstAvailableVariantId = colorObj.first_available_variant_id;
  let isActive = false;

  if (prodItem.querySelector('[data-prod-id]').getAttribute('data-prod-id') == productId) {
    isActive = true;
  }

  // Get the color hexcode/image for swatches based on metaObject Value
  if (isImage) {
    colorSwatch = `background-image: url('${createSizedImageUrl(
      metaImage,
      50,
    )}'); background-size: contain;`;
  } else if (swatchType.toLowerCase().includes('hex')) {
    colorSwatch = `background-color: ${colorHex};`;
  } else {
    colorSwatch = 'background-color: gray;';
  }

  function getLuminance(hex) {
    const rgb = hex.replace('#', '').match(/.{2}/g).map(c => {
      const val = parseInt(c, 16) / 255;
      return val <= 0.03928
        ? val / 12.92
        : Math.pow((val + 0.055) / 1.055, 2.4);
    });

    return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
  }

  // Inserting the color swatches
  if (!productInfo || !specificProductRelatedColors) {
    const swatchOutput = isImage
      ? `background-image: url(${createSizedImageUrl(metaImage, 50)})`
      : `${colorSwatch}`;
    const prodId = prodItem.querySelector('.js-product-data').dataset.prodId || 'color';
    colorsElement = `
    <input type="radio" id="${prodId}-${colorId}" name="${prodId}" class="screenreader pdp--legacy-swatch__radio-input" onchange="multiSwatchChange(this)">
    <label for="${prodId}-${colorId}" data-href="${colorURL}" data-feat-img="${featImg}" data-alt-img="${altImg}" class="pdp--legacy-swatch__container" data-active="${isActive}" style="${swatchOutput}">
      <span class="screenreader">${colorTitle}</span>
    </label>
  `;
  }
  let luminanceClass = '';
  if (!isImage && /^#([0-9a-f]{3}){1,2}$/i.test(colorHex.trim())) {
    const luminance = getLuminance(colorHex.trim());
    luminanceClass = luminance > 0.5 ? 'is-light' : 'is-dark';
  }

  const divElement = document.createElement('div');
  divElement.setAttribute('data-swatch-prod-available', productAvailability);
  divElement.classList.add('hp-recommendation__swatch');
  if (luminanceClass) divElement.classList.add(luminanceClass);
  divElement.innerHTML = colorsElement;
  const fieldset = prodItem.querySelector('.swatch-list__fieldset')

  if (fieldset.childElementCount <= 3) {
    fieldset.appendChild(divElement);
  } else {
    if (!prodItem.querySelector('.swatch-list .more-label')) {
      var extraSwatchesLabel = document.createElement('a');
      extraSwatchesLabel.classList.add('more-label');
      extraSwatchesLabel.setAttribute('href', '#');
      extraSwatchesLabel.setAttribute('data-extra-swatch-num', 1);
      fieldset.parentNode.insertBefore(extraSwatchesLabel, fieldset.nextSibling);
    } else {
      let swatchIndex = prodItem.querySelector('.swatch-list .more-label').getAttribute('data-extra-swatch-num');
      swatchIndex++;
      prodItem.querySelector('.swatch-list .more-label').setAttribute('data-extra-swatch-num', swatchIndex);
    }
  }

  if (colorObj.handle != 'psycho-bunny-gift-box' && formColors) {
    // Add color DOM
    formColors.insertAdjacentHTML('beforeend', colorsElement);
  }
};

const multiColorToggle = () => {
  const allColorSelectors = [
    ...document.querySelectorAll('.js-form-colors .swatch label'),
  ];
  const colorTitle = document.querySelector('.js-color-name');

  allColorSelectors.forEach((color) => {
    // Hovering on the color swatches
    color.addEventListener('mouseover', (e) => {
      if (
        document.querySelector('.js-swatch input:checked + label').dataset
          .productId != color.dataset.productId
      ) {
        colorTitle.innerText = color.querySelector('span').textContent;
      }
    });

    // Hovering off the color swatches
    color.addEventListener('mouseout', (e) => {
      colorTitle.innerText = document.querySelector(
        '.js-swatch input:checked + label span'
      ).textContent;
    });
  });
};

const observeSwatchWrapper = (callback) => {
  const firstSwatchWrapper = document.querySelector('.swatches-wrapper');
  if (!firstSwatchWrapper) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        callback();
        observer.unobserve(firstSwatchWrapper);
      }
    });
  });

  observer.observe(firstSwatchWrapper);
};

const multiColorSwatchesInit = () => {
  observeSwatchWrapper(() => {
    document.querySelectorAll('.card-wrapper.ProductItem').forEach(prodItem => {
      try {
        let variant_color_handles = '';
        try {
          variant_color_handles = JSON.parse(JSON.stringify(prodItem.querySelector('[data-variant-info]').getAttribute('data-variant-info')));
        } catch (error) {
          console.log('error grabbing swatch data: ', error, prodItem);
          variant_color_handles = {};
        }

        const colorJSON = JSON.parse(variant_color_handles);
        const currentProductHandle = prodItem.querySelector('[data-prod-handle]').getAttribute('data-prod-handle');
        colorJSON.push(currentProductHandle);
        document.querySelector('.product-form__input-items');
        const formSelect = document.querySelector('.js-form-select');
        const productMediaShare = document.querySelector('.js-product-media-share');
        const productMediaImages = document.querySelector('.js-social-media-image-share');
        let colorsElement;
        let ajax_calls = [];
        let allColors = [];
        let sizeElementDOM = '';
        let selectElementDOM = '';
        let socialShareDOM = '';
        let colorCount = 0;

        if (colorJSON.length < 2) {
          fetch(`/products/${currentProductHandle}?view=json`)
            .then(response => response.json())
            .then(resp => {
              let colorObj = resp;
              retrieveMultiProduct(colorsElement, colorObj, 'product', prodItem);
              colorCount++;
              document.dispatchEvent(new CustomEvent('swatches:loaded'));
            })
            .catch(error => {
              console.error('Error fetching product data:', error);
            });
          return;
        }

        const promiseState = (p) =>
          p.then(
            (v) => ({ v, status: 'fulfilled' }),
            (e) => ({ e, status: 'rejected' })
          );

        colorJSON.forEach((handle) => {
          ajax_calls.push(
            fetch(`/products/${handle}?view=json`)
              .then((response) => {
                if (!response.ok) {
                  console.warn('Product doesn\'t exist: ', handle);
                }
                return response.json();
              })
              .then((parsedContent) => {
                allColors.push(parsedContent);
              })
              .catch((error) => {
                console.warn('Fetch error:', error);
              })
          );
        });

        Promise.all(ajax_calls.map(promiseState)).then(function () {
          // Sort all the colors alphabetically
          allColors.sort(function (a, b) {
            var colorA = a.color;
            var colorB = b.color;
            return colorA < colorB ? -1 : colorA > colorB ? 1 : 0;
          });

          if (allColors.length > 1) {
            prodItem.querySelector('.available-colors p').innerHTML = `${allColors.length} colors available`;
          }

          // Loop through each color
          allColors.forEach((colorObj, index) => {
            const productId = colorObj.id;
            const colorId = 'color--' + colorObj.id;
            const productHandle = colorObj.handle;
            const productTitle = colorObj.title;
            const productDescription = colorObj.description_strip;
            const productFeaturedImage = colorObj.featured_image;

            retrieveMultiProduct(colorsElement, colorObj, 'product', prodItem);

            if (index <= 2) {
              const firstImage = colorObj.images[0];
              const imageContent = `
                <span data-image-id="${firstImage.id}" data-color-id="${colorId}" class="Product__SlideshowNavImage AspectRatio is-selected" style="--aspect-ratio: ${firstImage.aspect_ratio}">
                  <img data-src="${firstImage.src}" class="Image--lazyLoad" height="160px" width="160px" style="height: 160px; width: 160px;">
                </span>
              `;
            }
          });

          document.dispatchEvent(new CustomEvent('swatches:loaded'));
          multiColorToggle();
          if (prodItem.querySelector('.swatch-list .more-label')) {
            let swatchIndex = prodItem.querySelector('.swatch-list .more-label').getAttribute('data-extra-swatch-num');
            let handle = prodItem.querySelector('.card__media').href;
            prodItem.querySelector('.swatch-list .more-label').href = handle;
            prodItem.querySelector('.swatch-list .more-label').innerHTML = `+${swatchIndex} colors`;
          }
        });
      } catch (error) {
        console.log('error loading swatches for prod.', prodItem, error);
      }
    });
  });
};

document.addEventListener('DOMContentLoaded', multiColorSwatchesInit);

function multiSwatchChange(swatch) {
  const label = swatch.nextElementSibling;
  let container = label.closest('.ProductItem');
  let prodAvail = label.parentElement.getAttribute('data-swatch-prod-available');
  if (prodAvail === 'true') {
    container.querySelector('.card__badge').classList.add('hide-badge');
    container.querySelector('.card__badge').setAttribute('aria-hidden', true);
  } else {
    container.querySelector('.card__badge').classList.remove('hide-badge');
    container.querySelector('.card__badge').removeAttribute('aria-hidden');
  }
  container.querySelector('h3 a').href = label.getAttribute('data-href');
  try {
    container.querySelector('.pdp--legacy-swatch__container[data-active="true"]').removeAttribute('data-active');
  } catch (error) {
  }
  label.setAttribute('data-active', 'true');
  container.querySelector('.img-main').src = label.getAttribute('data-feat-img');
  container.querySelector('.card__media').href = label.getAttribute('data-href');
}
